const DIVIDED_SECTION_ORDER = {
  CITE_IMAGE: 'cite : image',
  IMAGE_CITE: 'image : cite',
};

export default DIVIDED_SECTION_ORDER;



// WEBPACK FOOTER //
// ./src/common/consts/dividedSectionOrder.js